import { createRoot } from '@wordpress/element';
import { SearchPage } from './coveo-headless/SearchPage.tsx';
import { buildSearchEngine } from '@coveo/headless';
import { default as getCoveoToken } from '../../../assets/js/modules/coveo-utils.js';

document.addEventListener( 'DOMContentLoaded', async () => {
	const props = {};
	const initialToken = await getCoveoToken();
	const commonConfig = {
		accessToken: initialToken,
		organizationId: COVEO_ORG_ID ?? '',
		renewAccessToken: getCoveoToken,
		analytics: { analyticsMode: 'legacy' },
	};

	const container = document.querySelector( '.coveo-advanced-query' );

	if ( container ) {
		props.engine = buildSearchEngine( {
			configuration: {
				...commonConfig,
				search: {
					pipeline: 'mainPipeline',
					searchHub: COVEO_SEARCH_HUB
				}
			},
			preloadedState: window.HEADLESS_STATE,
		} );

		props.secondEngine = buildSearchEngine( {
			configuration: {
				...commonConfig,
				search: {
					pipeline: 'videoPipeline',
					searchHub: COVEO_SEARCH_HUB
				}
			},
			preloadedState: window.HEADLESS_STATE,
		} );

		for ( const attr of container.attributes ) {
			props[ attr.name ] = attr.value;
		}

		let facets_array = Array.from( container.querySelectorAll( '.coveo-advanced-query__facet' ) ).map( ( facet ) => {
			const facetProps = {};
			for ( const attr of facet.attributes ) {
				facetProps[ attr.name ] = attr.value;
			}
			return facetProps;
		} );
		props.facets = facets_array;

		let pagination_container = container.querySelector( '.coveo-advanced-query__pagination' );
		if ( pagination_container ) {
			props.pagination = {};
			for ( const attr of pagination_container.attributes ) {
				props.pagination[ attr.name ] = attr.value;
			}
		}

		// Use a Map to cache the root component for the container to prevent calling `createRoot` multiple times.
		let root = rootCache.get( container );
		if ( ! root ) {
			// Create a new root and store it in the cache
			root = createRoot( container );
			rootCache.set( container, root );
		}

		root.render( <SearchPage { ...props } /> );
	}
} );
